import React__default, { forwardRef, useState, useRef, useEffect, useImperativeHandle } from 'react';
import AppTextAreaInputStyles from './AppTextAreaInput.module.scss.js';
import HelperStyles from '../../scss/helper.module.scss.js';
import ValidationError from '../validation-error/ValidationError.js';
import { getHeightByViewPort } from '../../methods/getSizeByViewPort.js';
import 'bowser';
import '../../_virtual/_tslib.js';
import '../../constants/authorizedUsers.js';
import '../../constants/bidStatus.js';
import '../../constants/bulkLoadCardStatus.js';
import '../../constants/misc.js';
import '../../constants/event-names.js';
import '../../constants/eventsMapObj.js';
import '../../constants/Faq.js';
import '../../constants/languages.js';
import '../../constants/loadStatus.js';
import '../../constants/lorryStatus.js';
import '../../constants/lorryTypes.js';
import '../../constants/mostSearchedLinks.js';
import '../../constants/Pages.js';
import '../../constants/serviceTypeId.js';
import '../../constants/StateList.js';
import '../../constants/bidUpdateType.js';
import '../../constants/userAction.js';
import '../../constants/api.js';
import '../../constants/link.js';
import '../../constants/market.js';
import '../../constants/payment.js';
import '../../constants/admin/screenId.js';
import '../../_services/const.js';
import '../toast/toast.js';
import '../../_services/auth.service.js';
import '../../methods/getAuthIdParam.js';
import 'react-cookie';
import '../../methods/formatDate.js';
import '../../methods/getTransporterFigure.js';
import '../../methods/getDownloadsFigure.js';
import 'lodash.isequal';
import '../../methods/getPageLoadSourceUTMParam.js';
import 'crypto-js';
import classNames from 'classnames';

const AppTextAreaInput = forwardRef(({ name, isRequired = false, labelText, value, onChange, onBlur, onFocus, error, isActiveByDefault = false, labelStyles = {}, containerStyles = {}, inputWrapperStyles = {}, inputStyles = {}, placeholder, setFocus = 0, autoComplete = true, className, containerClassName, labelClassName, inputWrapperClassName, inputTextAreaClassName, activeClassName, dirtyClassName, showValidationErrOnChange = true, disabled = false, errorClass, maxlength, fieldType = "flat" }, ref) => {
    const [isActive, setIsActive] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    const inputRef = useRef(null);
    const _onFocus = (e) => {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
        setIsActive(true);
    };
    const _onBlur = (e) => {
        e.persist();
        setIsDirty(!!e.target.value);
        setIsActive(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    };
    const _onChange = (e) => {
        e.persist();
        showValidationErrOnChange && setIsDirty(!!e.target.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
    };
    useEffect(() => {
        if (setFocus) {
            setTimeout(() => {
                var _a;
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 1);
        }
    }, [setFocus]);
    const focus = () => {
        setTimeout(() => {
            var _a;
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 1);
    };
    useImperativeHandle(ref, () => ({
        focus
    }));
    useEffect(() => {
        if (isActiveByDefault && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isActiveByDefault]);
    return (React__default.createElement("div", { className: classNames(disabled && AppTextAreaInputStyles.disabled, className, AppTextAreaInputStyles.textAreaWrapper) },
        React__default.createElement("div", { className: classNames(HelperStyles.center_vertical, AppTextAreaInputStyles.field_group, isActive && AppTextAreaInputStyles.active, isActive && activeClassName, (isDirty || value) && error && AppTextAreaInputStyles.invalid, containerClassName, AppTextAreaInputStyles[fieldType]), style: containerStyles },
            React__default.createElement("label", { htmlFor: name, className: classNames(isActive
                    ? AppTextAreaInputStyles.active + " " + activeClassName
                    : isDirty || value
                        ? AppTextAreaInputStyles.dirty + " " + dirtyClassName
                        : "", AppTextAreaInputStyles.label, labelClassName), style: labelStyles },
                labelText,
                isRequired && " *"),
            React__default.createElement("div", { style: Object.assign({}, inputWrapperStyles), className: classNames(AppTextAreaInputStyles.input_wrapper, inputWrapperClassName) },
                React__default.createElement("textarea", { ref: inputRef, name: name, onChange: _onChange, onFocus: _onFocus, onBlur: _onBlur, className: classNames(AppTextAreaInputStyles.inputTextArea, inputTextAreaClassName), value: value, style: inputStyles, placeholder: placeholder, autoFocus: isActiveByDefault, autoComplete: !autoComplete ? "off" : undefined, disabled: disabled, maxLength: maxlength }))),
        error && (React__default.createElement(ValidationError, { error: isDirty ? error : "", style: { marginTop: getHeightByViewPort(8) }, errorClass: classNames(errorClass) }))));
});

export { AppTextAreaInput as default };
//# sourceMappingURL=AppTextAreaInput.js.map
